import { MedicalRecordType } from './types';

export interface RecordTypeConfig {
  key: MedicalRecordType;
  label: string;
  countKey: keyof {
    providerNotes: number;
    imaging: number;
    procedures: number;
    labResults: number;
    pathologyResults: number;
    medications: number;
    vitals: number;
    problems: number;
    encounters: number;
    additionalRecords: number;
    originalRecords: number;
  };
}

export const RECORD_TYPES: RecordTypeConfig[] = [
  {
    key: 'originalRecords',
    label: 'Original Records',
    countKey: 'originalRecords',
  },
  {
    key: 'providerNotes',
    label: 'Provider/Facility Notes',
    countKey: 'providerNotes',
  },
  { key: 'imaging', label: 'Imaging', countKey: 'imaging' },
  { key: 'procedures', label: 'Procedures', countKey: 'procedures' },
  { key: 'labResults', label: 'Lab Results', countKey: 'labResults' },
  {
    key: 'pathologyResults',
    label: 'Pathology Results',
    countKey: 'pathologyResults',
  },
  { key: 'medications', label: 'Medications', countKey: 'medications' },
  { key: 'vitals', label: 'Vitals', countKey: 'vitals' },
  { key: 'problems', label: 'Problems', countKey: 'problems' },
  { key: 'encounters', label: 'Encounters', countKey: 'encounters' },
  {
    key: 'additionalRecords',
    label: 'Additional',
    countKey: 'additionalRecords',
  },
];

export const DEFAULT_RECORD_TYPE: MedicalRecordType = 'originalRecords';
